import React, { useState } from "react";
import UpdateLabel from "./UpdateLabel";
import "assets/scss/style.css";
import { Trans } from "react-i18next";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { getTextColor } from 'services/util';

const Label = ({ label, handleUpdateLabel, handleDeleteLabel, employees, selectedOrganisation }) => {
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [confirmDeleteLabel, setConfirmDeleteLabelModal] = useState(false);

    const handleEdit = () => {
        setShowUpdateModal(true);
    };

    const textColor = getTextColor(label.color_code);

    const handleDeleteLabelClick = (e) => {
        setConfirmDeleteLabelModal(true);
    };
    const handleConfirmDelete = async () => {
        await handleDeleteLabel(label);
        setConfirmDeleteLabelModal(false);
    };
    const handleCancelDelete = () => {
        setConfirmDeleteLabelModal(false);
    };

    return (
        <>
            <tr>
                <td className="text-left" >
                    <div className="justify-content-center d-flex" style={{ backgroundColor: label.color_code, color:textColor, padding:"10px", width:"130px", borderRadius:"3px" }}>
                    <Trans>{label.label_name}</Trans>
                    </div>
                </td>
                <td  className="text-center">
                    <Button color="primary" onClick={handleEdit}><i className={`fa fa-edit`}></i></Button>
                    <Button color="danger" onClick={handleDeleteLabelClick}><i className={`fa fa-trash`}></i></Button>
                </td>
            </tr>
            {showUpdateModal && (
                <UpdateLabel
                    label={label}
                    onClose={() => setShowUpdateModal(false)}
                    onSave={handleUpdateLabel}
                    employees={employees}
                    selectedOrganisation={selectedOrganisation}
                />
            )}
            <Modal isOpen={confirmDeleteLabel} toggle={() => setConfirmDeleteLabelModal(false)}>
                <ModalHeader toggle={() => setConfirmDeleteLabelModal(false)}><Trans>Confirm Delete</Trans></ModalHeader>
                <ModalBody>
                    <Trans>Are you sure you want to delete </Trans> <strong>{label?.label_name}</strong>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleConfirmDelete}>
                        <Trans>Delete</Trans>
                    </Button>{' '}
                    <Button color="secondary" onClick={handleCancelDelete}>
                        <Trans>Cancel</Trans>
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default Label;
